import { render, staticRenderFns } from "./WelcomeBox.vue?vue&type=template&id=0516b956&scoped=true&"
var script = {}
import style0 from "./WelcomeBox.vue?vue&type=style&index=0&id=0516b956&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0516b956",
  null
  
)

export default component.exports